import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import TransactionTable from '../../../components/tables/TransactionTable';

const PendingTransaction = () => {
  // Sample data generator for pending transactions
  const generateSampleData = () => {
    const userRoles = [
      'Super Distributor',
      'Master Distributor',
      'Distributor',
      'Retailer',
      'API Partner'
    ];
    const types = ['Credit', 'Debit'];
    const names = [
      'Rajesh Kumar', 'Priya Sharma', 'Amit Patel', 'Sneha Reddy',
      'Vikram Singh', 'Anjali Gupta', 'Rahul Verma', 'Neha Joshi',
      'Suresh Yadav', 'Kavita Mehta', 'Arun Kumar', 'Pooja Singh',
      'Deepak Sharma', 'Ritu Agarwal', 'Manoj Tiwari', 'Swati Desai',
      'Sanjay Rao', 'Meera Nair', 'Karan Khanna', 'Divya Saxena'
    ];

    return Array.from({ length: 40 }, (_, i) => {
      const transactionDate = new Date(
        2024,
        Math.floor(Math.random() * 12),
        Math.floor(Math.random() * 28) + 1
      );

      return {
        id: `TXN${String(i + 1).padStart(6, '0')}`,
        userName: names[Math.floor(Math.random() * names.length)],
        userRole: userRoles[Math.floor(Math.random() * userRoles.length)],
        type: types[Math.floor(Math.random() * types.length)],
        amount: [500, 1000, 2000, 5000, 10000, 15000, 20000, 25000][
          Math.floor(Math.random() * 8)
        ],
        transactionDate: transactionDate.toISOString().split('T')[0],
        status: 'Pending'
      };
    });
  };

  const [transactionsData] = useState(generateSampleData());

  return (
    <Container fluid className="">
      <TransactionTable
        data={transactionsData}
        title="Pending Transactions"
      />
    </Container>
  );
};

export default PendingTransaction;

